<template>
  <ul class="category_chk_wrap">
    <!-- li :style 2021.01.04 이후 삭제 -->
    <li
      v-for="category in surveyCategory"
      :key="category.cd"
      :style="category.display"
    >
      <input
        :id="category.cd"
        type="radio"
        name="category"
        :value="category.value"
        @change="choiceCategory(category.value)"
      >
      <label :for="category.cd">
        <div class="rdo_img"><i /> {{ category.name }}</div>
      </label>
    </li>
  </ul>
</template>

<script>

import {
  RECOMMENDATION_QUESTION_GROUP,

} from '@/utils/constants';

export default {
  name: 'SurveyCategoryCheck',
  data() {
    return {
      surveyCategory: [
        { cd: 'category_chk01', name: '면역', value: RECOMMENDATION_QUESTION_GROUP.IMMUNITY },
        { cd: 'category_chk02', name: '어린이/청소년', value: RECOMMENDATION_QUESTION_GROUP.YOUTH },
        { cd: 'category_chk03', name: '중년여성', value: RECOMMENDATION_QUESTION_GROUP.WOMAN },
        { cd: 'category_chk04', name: '중년남성', value: RECOMMENDATION_QUESTION_GROUP.MAN },
        { cd: 'category_chk05', name: '항산화', value: RECOMMENDATION_QUESTION_GROUP.ANTIOXIDATION },
        { cd: 'category_chk06', name: '눈건강', value: RECOMMENDATION_QUESTION_GROUP.EYE },
        { cd: 'category_chk07', name: '활력', value: RECOMMENDATION_QUESTION_GROUP.ENERGY },
      ],
    };
  },
  created() {
    // 2021.01.05 이후 삭제코드
    const dueDate = new Date(2021, 0, 5, 10, 0, 0);
    const now = new Date();
    if (now < dueDate) {
      this.surveyCategory[0].display = 'display: none';
    }
  },
  methods: {
    choiceCategory(value) {
      this.$emit('choice-category', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/survey/main/partial/SurveyCategoryCheck.vue